class VerticalTabs {
  constructor() {
    
    this.wrapper = document.querySelectorAll('.vertical-tabs');

    // console.log(document.querySelector('.vertical-tabs'));
    // console.log(this.wrapper);
    
    if (!this.wrapper) {
      return false;
    }

    this.wrapper.forEach((item) => {
      new VerticalTab(item);
    });

  }
}

class VerticalTab {
  constructor(tabWrapper) {

    this.navigationList = tabWrapper.querySelector('.vertical-tabs-navigation');
    this.contentList = tabWrapper.querySelector('.vertical-tabs-content'); 
    this.displayTab = this.displayTab.bind(this);

    this.displayTab(0);

    this.navigationList.querySelectorAll('a').forEach((item, index) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        this.displayTab(index);
      });
    });
  }

  displayTab(index) {
    this.navigationList.querySelectorAll('a').forEach((item) => {
      item.classList.remove('active');
    });

    this.contentList.querySelectorAll('.tab-item').forEach((item) => {
      item.classList.remove('active');
    });

    this.navigationList.querySelectorAll('a')[index].classList.add('active');
    this.contentList.querySelectorAll('.tab-item')[index].classList.add('active');
  }

}

export default VerticalTabs;